import { render } from "./group-size.vue?vue&type=template&id=6fe62913&lang=pug"
import script from "./group-size.vue?vue&type=script&lang=js"
export * from "./group-size.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__